import { SlotDurationMs, msToSlotsCeilNum } from '@velocity-exchange/sdk';

/** `Order.auctionDuration` is a u8, so an inflated ramp clamps here. */
const MAX_AUCTION_DURATION_SLOTS = 255;

/**
 * The auction ramp a trader asks for is wall-clock, so it converts at the live
 * slot length and ceils: flooring would hand back a shorter auction than the
 * one they chose.
 */
export const auctionDurationMsToSlots = (
	durationMs: number,
	slotDuration: SlotDurationMs
): number =>
	Math.min(
		msToSlotsCeilNum(durationMs, slotDuration),
		MAX_AUCTION_DURATION_SLOTS
	);

export const auctionDurationSecondsToSlots = (
	durationSeconds: number,
	slotDuration: SlotDurationMs
): number => auctionDurationMsToSlots(durationSeconds * 1000, slotDuration);
